// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-label__sub_is-error {
  position: absolute;
  bottom: 210px;
}

.input-container {
  display: flex;
  width: 100%;
  color: var(--text-color);
  flex-wrap: wrap;
}
.input-container_inline {
  flex-wrap: nowrap;
}
.input-container .label {
  width: 100%;
  font-size: 14px;
  margin-right: 8px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
.input-container .label_inline {
  width: 192px;
  font-size: 12px;
}
.input-container .value {
  flex: 1;
}

.floating-input {
  position: relative;
  margin-top: 1.5rem;
  width: 100%;
}
.floating-input input.c-input {
  padding: 12px 12px 6px 5px;
  line-height: 18px;
  font-size: 14px;
  width: 100%;
  border: none;
  border-bottom: 1px solid #A2A8AE;
  outline: none;
  box-shadow: none;
  background: none;
  transition: border-color 0.2s ease;
}
.floating-input .floating-label {
  position: absolute;
  left: 5px;
  top: 10px;
  color: #A2A8AE;
  font-size: 14px;
  pointer-events: none;
  transition: 0.2s ease all;
}
.floating-input .required {
  color: #A2A8AE;
  margin-left: 0.25rem;
}
.floating-input input.c-input:focus {
  border-bottom: 1px solid #A2A8AE;
  border-top: none;
  border-left: none;
  border-right: none;
  box-shadow: none;
}
.floating-input input.c-input:hover {
  border-bottom: 1px solid #A2A8AE;
  border-top: none;
  border-left: none;
  border-right: none;
  box-shadow: none;
}
.floating-input.filled .floating-label,
.floating-input input.c-input:focus + .floating-label {
  top: -10px;
  left: 0;
  font-size: 12px;
  padding: 0 4px;
  color: #A2A8AE;
}

input.c-input:-webkit-autofill {
  box-shadow: 0 0 0 1000px var(--autofill-bg) inset !important;
  -webkit-box-shadow: 0 0 0 1000px var(--autofill-bg) inset !important;
  -webkit-text-fill-color: var(--autofill-text) !important;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
